export default [
  {
    x: 76,
    y: 6,
    size: 10,
    opacity: 0.4,
    delay: 0.1,
  },
  {
    x: 40,
    y: -16,
    size: 16,
    opacity: 0.2,
    delay: 0.4,
  },
  {
    x: 24,
    y: -30,
    size: 10,
    opacity: 0.2,
    delay: 2.26,
  },
  {
    x: -6,
    y: -10,
    size: 7,
    opacity: 0.2,
    delay: 0.8,
  },
  {
    x: 7,
    y: 32,
    size: 10,
    opacity: 0.2,
    delay: 1.1,
  },
  {
    x: -4,
    y: 20,
    size: 15,
    opacity: 0.4,
    delay: 1.6,
  },
  {
    x: 64,
    y: 17,
    size: 12,
    opacity: 0.2,
    delay: 0.2,
  },
  {
    x: 78,
    y: -22,
    size: 8,
    opacity: 0.1,
    delay: 1.4,
  },
  {
    x: 46,
    y: 12,
    size: 6,
    opacity: 0.4,
    delay: 0.76,
  },
];
